import unescape from 'lodash/unescape'

/**
 * bringing the apostrophe to a single code
 * getting from the API &#039;, but lodash unescape uses &#39; to convert it to the apostrophe
 */
export default function customUnescape(value?: string | number | null): string {
  return unescape(value?.toString()?.replace(/&#039;/g, '&#39;') || '')
}
